export default __webpack_public_path__ + "img/66fad3afa1e50b153a27e9d6d8ecc27d.svg";